import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CollateralskillsetsService } from '../collateralskillsets.service';
import { PropertyTypeService } from '../property-type.service';
import { PropertyType, AddPropertyType } from '../property-type.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-property-type-add',
  templateUrl: './property-type-add.component.html',
  styleUrls: ['./property-type-add.component.css']
})
export class PropertyTypeAddComponent implements OnInit {

    public PropertyTypeForm: FormGroup;
    public productSkillSets;
    public propertyFields;

    constructor(public dialogRef: MatDialogRef<PropertyTypeAddComponent>, private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public propertyType: PropertyType, private collateralSkilSetService: CollateralskillsetsService,
        private propertyTypeService: PropertyTypeService)
    { this.createForm(); }

    ngOnInit() {
        this.propertyFields = environment.propertyFields;
        this.getProductSkillset();
    }

    createForm() {
        this.PropertyTypeForm = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(255)]],
            productSkillSet: [null, Validators.required],
            propertyField: [null, Validators.required],
            isRetail : [false]
        });
    }

    onSubmit() {
        if (!this.PropertyTypeForm.valid) {
            return;
        }
        const formModel = this.PropertyTypeForm.value;
        const savePropertyType: AddPropertyType = {
            name: formModel.name as string,
            productSkillsetId: formModel.productSkillSet as string,
            propertyField: formModel.propertyField as string,
            isRetail: formModel.isRetail as boolean
        };
        this.propertyTypeService.addPropertyTypes(savePropertyType)
            .then(result => this.dialogRef.close(result))
            .catch(error => console.log(error));
    }

    async getProductSkillset() {
        let result = await this.collateralSkilSetService.getProductSkillSet();
        this.productSkillSets = result;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-add/property-type-add.component.ts